import axios from 'axios';

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_BACKEND || import.meta.env.VITE_API_SERVER,
  headers: {
    'Content-Type': 'application/json',
  },
});

const TOKEN: string = import.meta.env.VITE_TOKEN_BE as string;

axiosClient.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken && config.headers) {
      config.headers.Authorization = `Bearer ${jwtToken}`;
    }
    if (
      config.method === "post" &&
      config.data !== undefined &&
      typeof config.data === "object"
    ) {
      config.data = {
        ...(config.data as object),
        token: TOKEN,
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('lineToken');
      localStorage.removeItem('lineProfile');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
